import { AgeSelectProps } from "@/components/Inputs/AgeSelect/AgeSelectProps.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { ChangeEvent } from "react";

export const AgeSelect = (props: AgeSelectProps) => {
  const [setCartItemChildAge, setCartItemAdultAge] = useEngineStore((state) => [
    state.setCartItemChildAge,
    state.setCartItemAdultAge,
  ]);

  const ageOptions = Array.from({ length: 18 }, (_, index) => index)?.map((age, i) => {
    const renderAge = i === 0 ? "< 1" : age;
    return (
      <option key={age} value={Number(age)}>
        {renderAge}
      </option>
    );
  });

  const adultAgeOptions = Array.from({ length: 82 }, (_, index) => index)?.map((age) => {
    const actualAge = age + 18;
    return (
      <option key={actualAge} value={Number(actualAge)}>
        {actualAge}
      </option>
    );
  });

  const handleOnSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (props.isAdult) {
      setCartItemAdultAge(props.person.id, e.target.value as unknown as number, props.cartItemId);
    } else {
      setCartItemChildAge(props.person.id, e.target.value as unknown as number, props.cartItemId);
    }
  };

  return (
    <div>
      <select className="c-be-select" value={props.person.age!} onChange={handleOnSelectChange}>
        {props.isAdult ? adultAgeOptions : ageOptions}
      </select>
    </div>
  );
};
